import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7b38229a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row q-mb-none" }, [
  /*#__PURE__*/_createElementVNode("span", null, "* : champs obligatoires")
], -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row q-mb-md" }, [
  /*#__PURE__*/_createElementVNode("span", null, "# : item sélectionné")
], -1 /* HOISTED */))
const _hoisted_3 = { class: "q-gutter-sm" }

import { ref, reactive, computed, watch, onMounted } from 'vue';
import { QInput, QSelect } from 'quasar';

// Stores
import { useUiStore } from '@stores/ui';

// Personal components
import QPageTitle from '@components/QPageTitle.vue';
import QBtnCancel from '@components/form/QBtnCancel.vue';
import QBtnValid from '@components/form/QBtnValid.vue';
import QOfflineBanner from '@components/QOfflineBanner.vue';
import QInputEmail from '@components/form/QInputEmail.vue';
import QInputMessage from '@components/form/QInputMessage.vue';

// Personal libs
import contactRepository from '@data/repository/contact.repository';
import {
  displayNotifSuccess,
  displayDialogError,
} from '@shared/lib/notify.lib';
import { IConfig } from '@shared/interface/config.interface';
import { IUser } from '@shared/interface/model.interface';
import { ConfigDto } from '@data/dto/config-dto';
import { $t } from '@i18n/utils';
import { subjectRules, emailExample } from '@shared/lib/form.lib';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

interface IForm {
  email: string;
  objet: string;
  message: string;
  arrErrors?: Array<string>;
}

/**
 * Stores
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactPage',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
// Vendor
const uiStore = useUiStore();

/**
 * HTML Elements
 */
const qInputEmail = ref();
const qInputMessage = ref();
const qSelectSubject = ref<QSelect>();

/**
 * Reactive data
 */
const loading = ref<boolean>(false);
const form = reactive<IForm>({
  email: '',
  objet: '',
  message: '',
});

/**
 * Computed properties
 */
const connectedUser = computed<IUser | undefined>(
  () => sessionManager.currentUser.value,
);
const isOnline = computed(() => sessionManager.isOnline.value === true);
const config = computed<IConfig>(() => uiStore.config ?? new ConfigDto());
const subjectList = computed<Array<string>>(
  () => config.value.contact?.subjects ?? [],
);

/**
 * Methods
 */
function onSubmit() {
  qInputEmail.value?.validate();
  qInputMessage.value?.validate();
  qSelectSubject.value?.validate();

  if (
    qInputEmail.value?.hasError() ||
    qInputMessage.value?.hasError() ||
    qSelectSubject?.value?.hasError
  ) {
    return;
  }

  loading.value = true;

  contactRepository
    .postMessage({
      email: form.email,
      subject: form.objet,
      message: form.message,
      version: uiStore.changelog?.version?.frontend ?? 'inconnue',
    })
    .then(() => {
      displayNotifSuccess($t('contact.msg.success01'));
    })
    .catch((error) => {
      displayDialogError({ message: error.message ?? 'null' });
    })
    .finally(() => {
      loading.value = false;
      onReset();
    });
}

function onReset() {
  loading.value = false;

  // Reset our form values
  form.email = connectedUser.value?.email ?? '';
  form.objet = '';
  form.message = '';
  form.arrErrors = [];

  qInputEmail.value?.resetValidation();
  qInputMessage.value?.resetValidation();
  qSelectSubject.value?.resetValidation();

}

function setEmail(user?: IUser) {
  if (user?.email != null) {
    form.email = user.email;
  }
}

/**
 * Watched var
 */
watch(
  () => connectedUser.value,
  (newVal) => setEmail(newVal),
);

/**
 * Hooks
 */
onMounted(() => {
  setEmail(connectedUser.value);
});

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QPageTitle, { title: 'Contact' }),
    _createVNode(_component_q_form, {
      class: "q-ma-md q-pa-sm form-style",
      onSubmit: onSubmit,
      onReset: onReset,
      novalidate: ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createVNode(QInputEmail, {
          modelValue: form.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
          ref_key: "qInputEmail",
          ref: qInputEmail,
          label: `${_unref($t)('contact.msgEmail.label')} (ex: ${_unref(emailExample)})`
        }, null, 8 /* PROPS */, ["modelValue", "label"]),
        _createVNode(_unref(QSelect), {
          modelValue: form.objet,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.objet) = $event)),
          options: subjectList.value,
          ref_key: "qSelectSubject",
          ref: qSelectSubject,
          outlined: "",
          dense: "",
          class: "q-mb-sm",
          "input-class": [
        'set-outline',
        _ctx.$q.dark.isActive ? 'text-white' : 'text-black',
      ],
          "aria-required": "true",
          "aria-invalid": 
        !form.objet || (form.objet && form.objet.length < 3) ? 'true' : 'false'
      ,
          "label-color": _ctx.$q.dark.isActive ? 'white' : 'black',
          label: `* ${_unref($t)('contact.msgSubject.label')}`,
          "hide-bottom-space": "",
          "popup-content-class": "subjectOption",
          "lazy-rules": "",
          rules: _unref(subjectRules)
        }, {
          option: _withCtx((scope) => [
            _createVNode(_component_q_item, _mergeProps(scope.itemProps, {
              class: {
            'q-item-focused': scope.focused,
            'q-item-selected': scope.selected && !scope.focused,
          }
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.selected ? '# ' : '') + _toDisplayString(scope.opt), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "options", "input-class", "aria-invalid", "label-color", "label", "rules"]),
        _createVNode(QInputMessage, {
          modelValue: form.message,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.message) = $event)),
          ref_key: "qInputMessage",
          ref: qInputMessage,
          label: _unref($t)('form.message.label')
        }, null, 8 /* PROPS */, ["modelValue", "label"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(QBtnCancel, {
            type: 'reset',
            label: 'Effacer',
            disable: loading.value
          }, null, 8 /* PROPS */, ["disable"]),
          _createVNode(QBtnValid, {
            type: 'submit',
            label: 'Envoyer',
            loading: loading.value,
            "icon-right": 'check',
            title: 
          isOnline.value
            ? 'Envoyer le mail'
            : _unref($t)('generic.hasToBeOnline')
        ,
            disable: !isOnline.value
          }, null, 8 /* PROPS */, ["loading", "title", "disable"])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(QOfflineBanner)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})